import { Component } from "@theme/component";
class VolumePricingInfoComponent extends Component {
  /**
   * Ensures the parent anchored-popover-component refs are refreshed after connection,
   */
  connectedCallback() {
    super.connectedCallback();
    const anchoredPopover = this.closest("anchored-popover-component");
    if (anchoredPopover instanceof Component && anchoredPopover.isConnected) {
      try {
        anchoredPopover.updatedCallback();
      } catch (error) {
        Promise.resolve().then(() => {
          if (anchoredPopover.isConnected) {
            try {
              anchoredPopover.updatedCallback();
            } catch (e) {
            }
          }
        });
      }
    }
  }
  /**
   * Ensures the parent anchored-popover-component refs are refreshed immediately,
   */
  updatedCallback() {
    super.updatedCallback();
    const anchoredPopover = this.closest("anchored-popover-component");
    if (anchoredPopover instanceof Component) {
      anchoredPopover.updatedCallback();
    }
  }
  /**
   * Updates the highlighted price tier based on current quantity
   * @param {number} quantity - The current quantity
   */
  updateActiveTier(quantity) {
    var _a;
    const anchoredPopover = this.closest("anchored-popover-component");
    const popover = anchoredPopover instanceof Component ? (_a = anchoredPopover.refs) == null ? void 0 : _a.popover : null;
    const rows = popover == null ? void 0 : popover.querySelectorAll(".volume-pricing-info__row[data-quantity]");
    if (!rows) return;
    let activeTier = null;
    for (const row of rows) {
      row.classList.remove("volume-pricing-info__row--active");
      if (row instanceof HTMLElement && quantity >= parseInt(row.dataset.quantity || "0")) {
        activeTier = row;
      }
    }
    activeTier == null ? void 0 : activeTier.classList.add("volume-pricing-info__row--active");
  }
}
if (!customElements.get("volume-pricing-info")) {
  customElements.define("volume-pricing-info", VolumePricingInfoComponent);
}
